// Geminii external URLs — single source of truth.
// Update here when domains change; every CTA across the site picks it up.

export const DEMO_URL = "https://demo-rogue.geminii-ai.com/";
export const NEXUS_DEMO_URL = "https://demo-nexus.geminii-ai.com/";
// Note: nexus.geminii-ai.com currently serves the tenant portal (not a marketing site).
// The umbrella site /nexus section IS the marketing surface until the e-shop launches.
export const NEXUS_URL = "https://nexus.geminii-ai.com";
